import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.5.2_6210b4614a90d24ed7187407524aa20b/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}